export default {"src":"/_next/static/media/logo-new.7b2c9948.svg","height":46,"width":134};